import Report from '../../../model/Report'
import { replaceReport as apiReplaceReport } from '../../../rest-api/Report-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'

const actionCreator = actionCreatorFactory()

export const ReplaceReport = actionCreator.async<
  { market: string; report: Report; file: File },
  Report,
  string
>('ReplaceReport')

const replaceReportWorker = wrapAsyncWorker(
  ReplaceReport,
  (params: { market: string; report: Report; file: File }): Promise<Report> =>
    apiReplaceReport(params)
)

// thunk action creator
export const replaceReport = (market: string, report: Report, file: File) => {
  return (dispatch: Dispatch<AnyAction>) => replaceReportWorker(dispatch, { market, report, file })
}
